<script>
	
	export let title;
	export let text;
	export let img;
	export let url;
	
	

</script>

	

<div class="project"  on:click="{() => window.open(url)}">
	<div class="image"><a target="_blank" href={url} ><img src="./images/{img}" alt="{title} screenshot"></a></div>
	<div class="desc">
		<a target="_blank" href={url}><h3>{title}</h3></a>
		<p>{text}</p>
		<form action={url} method="get" target="_blank">
			<button type="submit" class="btn">→</button>
		 </form>
	</div>
</div>


		
	
<style>

	.project {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		background: #16181A;
		border: 1px solid #242424;
		box-sizing: border-box;
		box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 20px rgba(255, 255, 255, 0.05);
		border-radius: 10px;
		margin: 15px 0px;
		padding: 24px;
		gap: 24px;
		cursor: pointer;
	}

	.project:hover {
		box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 20px rgba(255, 255, 255, 0.25);
	}

	img {
		width: 335px;
		opacity: 0.5;
	}

	h3 {
		font-family: 'Poppins', 'Century Gothic', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 20px;
		text-transform: uppercase;
		color: #FF3263;
		margin: 0;
	}

	a:hover {
		text-decoration: none;
	}

	p {
		margin: 0 0 45px 0;
	}

	.desc {
		width: calc(100% - 360px);
		position: relative;
	}
	

	.btn {
        display: inline-block;
        margin-top: 15px;
        margin-bottom: 0;
        width: 30px;
        height: 30px;
        border-radius: 99px;
        border: 1px solid #343135;
        background-color: #00000000;
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000;
        background-repeat: no-repeat;
        background-position: center;
		color: #ccc;
		font-size: 14px;
		line-height: 14px;
		cursor: pointer;
    }
	form {
		position: absolute;
		bottom: 0;
		right: 0;
	}

	@media screen and (max-width: 760px) {
		.project {
			width: 400px;
		}
		.image {
			margin: 0 auto;
		}
		.desc {
			min-width: 335px;
			margin: 0 auto
		}
		form {
			right: inherit;
		}
	}

</style>